import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { Shield, Activity, Target } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TemplatesHeaderProps {
  propertyTypesCount: number;
}

export function TemplatesHeader({ propertyTypesCount }: TemplatesHeaderProps) {
  const { t, i18n } = useTranslation();
  const isRTL = useMemo(() => i18n.language === 'ar', [i18n.language]);

  return (
    <div className="bg-gradient-to-r from-primary via-primary/95 to-primary/90 text-primary-foreground p-8 shadow-2xl">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary-foreground/10 rounded-lg">
            <Target className="w-8 h-8" />
          </div>
          <div>
            <h1 className="text-3xl font-bold">
              {t('templates.admin.management.title')}
            </h1>
            <p className="text-primary-foreground/80 text-lg">
              {t('templates.admin.management.subtitle')}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4 mt-4">
          <Badge
            variant="secondary"
            className="bg-primary-foreground/20 text-primary-foreground border-primary-foreground/30"
          >
            <Shield className={cn('w-3 h-3', isRTL ? 'ml-1' : 'mr-1')} />
            {t('templates.admin.management.adminAccess')}
          </Badge>
          <Badge
            variant="secondary"
            className="bg-primary-foreground/20 text-primary-foreground border-primary-foreground/30"
          >
            <Activity className={cn('w-3 h-3', isRTL ? 'ml-1' : 'mr-1')} />
            {propertyTypesCount} {t('templates.admin.management.propertyTypes')}
          </Badge>
        </div>
      </div>
    </div>
  );
}
